'use client';

import { c as _c } from "react/compiler-runtime";
import type { StructuredContentDocument } from '@cc-shopping/contracts/cross-site/structured-content/types';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import type React from 'react';
import { Sparkle } from './icons/Sparkle';
export const TitleContainerStyled = styled(Box)(({
  theme
}) => ({
  backgroundColor: theme.palette.greens.darkest,
  borderRadius: theme.spacing(2),
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0
}));
export type SpotlightTitleProps = {
  details?: StructuredContentDocument;
  title?: string;
} & React.ComponentProps<typeof TitleContainerStyled>;
export const SpotlightTitle = t0 => {
  const $ = _c(30);
  let details;
  let props;
  let title;
  if ($[0] !== t0) {
    ({
      details,
      title,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = details;
    $[2] = props;
    $[3] = title;
  } else {
    details = $[1];
    props = $[2];
    title = $[3];
  }
  const theme = useTheme();
  let t1;
  if ($[4] !== theme.breakpoints) {
    t1 = theme.breakpoints.down("md");
    $[4] = theme.breakpoints;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const isMobile = useMediaQuery(t1);
  if (!details || !title) {
    return null;
  }
  const t2 = isMobile ? "center" : "left";
  let t3;
  if ($[6] !== t2) {
    t3 = {
      display: "flex",
      justifyContent: t2,
      alignItems: "center"
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = isMobile ? "center" : "left";
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: "greens.extraLight",
      fontSize: "20px"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== theme) {
    t6 = theme.spacing(1);
    $[9] = theme;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== theme) {
    t7 = theme.spacing(1);
    $[11] = theme;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isMobile || $[14] !== theme) {
    t8 = isMobile && {
      marginTop: theme.spacing(2),
      width: 16,
      height: 16
    };
    $[13] = isMobile;
    $[14] = theme;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <Sparkle style={{
      verticalAlign: "top",
      textAnchor: "start",
      marginTop: t6,
      marginRight: t7,
      ...t8
    }} />;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t4 || $[21] !== t9 || $[22] !== title) {
    t10 = <Typography align={t4} variant="textBold" sx={t5}>{t9}{title}</Typography>;
    $[20] = t4;
    $[21] = t9;
    $[22] = title;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t3) {
    t11 = <Box sx={t3}>{t10}</Box>;
    $[24] = t10;
    $[25] = t3;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== props || $[28] !== t11) {
    t12 = <TitleContainerStyled px={3.5} py={3} {...props}>{t11}</TitleContainerStyled>;
    $[27] = props;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
};